import React, { Component, useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { Tooltip, message, Divider, Spin, Space, Modal, Button, Empty, Alert, Drawer } from 'antd';
import { InfoCircleFilled, InfoCircleOutlined, QuestionCircleOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Chart, Axis, Line, Point, Tooltip as Tooltip$1, Legend, Interaction, Slider, Annotation } from 'bizcharts';
import moment from 'moment';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var ErrorBoundary$1 = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) return /*#__PURE__*/React.createElement("div", null);
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error(error);
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = ".TY_ICON-TIP--icon{margin-left:6px;cursor:pointer}.TY_ICON-TIP--icon.size_middle{font-size:14px}.TY_ICON-TIP--icon.size_small{font-size:12px}";
styleInject(css_248z$5);

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var IconTip = (function (props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'question' : _props$type,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      otherProps = _objectWithoutProperties(props, ["size", "type", "color", "filled"]);

  var _classNames = classnames(_defineProperty({
    'TY_ICON-TIP--icon': true
  }, "size_".concat(size), true));

  return /*#__PURE__*/React.createElement(Tooltip, otherProps, filled ? /*#__PURE__*/React.createElement(InfoCircleFilled, {
    className: _classNames,
    style: {
      color: color,
      marginRight: '6px'
    }
  }) : type === 'info' ? /*#__PURE__*/React.createElement(InfoCircleOutlined, {
    className: _classNames,
    style: {
      color: color,
      marginRight: '6px'
    }
  }) : /*#__PURE__*/React.createElement(QuestionCircleOutlined, {
    className: _classNames,
    style: {
      color: color,
      marginRight: '6px'
    }
  }));
});

var showDomain = {
  DEV: '/dev_api',
  TEST: '//test-seckill.shop.jd.com',
  PRE: '//pre-seckill.shop.jd.com',
  PROD: '//seckill.shop.jd.com',
  PRO: '//seckill.shop.jd.com',
  JDTEST: '//seckill-shop.jdtest.net'
};
var erpDomain = {
  DEV: '/dev_api',
  TEST: '//test-newseckill.jd.com',
  PRE: '//pre-newseckill.jd.com',
  PROD: '//newseckill.jd.com',
  PRO: '//newseckill.jd.com',
  JDTEST: '//newseckill.jdtest.net'
};
var apiDomain;

function addDomain(url) {
  if (typeof url !== 'string') return url;
  url = url.trim();
  if (url.indexOf('http') === 0 || url.indexOf('//') === 0) return url;
  return apiDomain + url;
}

var env;

(function (env) {
  env["DEV"] = "DEV";
  env["TEST"] = "TEST";
  env["PRE"] = "PRE";
  env["PRO"] = "PRO";
  env["JDTEST"] = "JDTEST";
})(env || (env = {}));

function setApiDomain(isShop, env) {
  if (isShop) apiDomain = showDomain[env] || showDomain.PRO;else apiDomain = erpDomain[env] || erpDomain.PRO;
}

function requestPost(_x3, _x4) {
  return _requestPost.apply(this, arguments);
}

function _requestPost() {
  _requestPost = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(api, data) {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            api = addDomain(api);
            _context2.next = 4;
            return fetcher({
              api: api,
              option: {
                method: 'POST',
                body: data || {}
              }
            });

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _requestPost.apply(this, arguments);
}

function fetcher(_x5) {
  return _fetcher.apply(this, arguments);
}

function _fetcher() {
  _fetcher = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref) {
    var api, _ref$option, option, tmpQuery, url, fetchJson, json;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            api = _ref.api, _ref$option = _ref.option, option = _ref$option === void 0 ? {} : _ref$option;
            option.mode = 'cors';
            option.credentials = 'include';
            option.headers = {};

            if (option.body instanceof window.FormData) ; else {
              if (option.body instanceof Object) {
                option.headers['Content-Type'] = 'application/json; charset=utf-8';
                option.body = JSON.stringify(option.body);
              } else {
                option.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
              }
            }

            tmpQuery = option.query ? formatQueryObj(option.query) : '';
            url = tmpQuery ? api + (api.indexOf('?') !== -1 ? '&' : '?' + tmpQuery) : api;
            _context3.prev = 7;
            _context3.next = 10;
            return window.fetch(url, option);

          case 10:
            fetchJson = _context3.sent;
            _context3.next = 13;
            return fetchJson.json();

          case 13:
            json = _context3.sent;
            return _context3.abrupt("return", handleError(json));

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](7);
            console.error(_context3.t0);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[7, 17]]);
  }));
  return _fetcher.apply(this, arguments);
}

function handleError(res) {
  var ret = res.ret;

  switch (ret) {
    case '3':
      {
        return res;
      }

    case '0':
      {
        return res;
      }

    default:
      {
        return res;
      }
  }
}

function formatQueryObj(obj) {
  var res = Object.keys(obj).reduce(function (prev, cur) {
    return "".concat(prev).concat(encodeURIComponent(cur), "=").concat(encodeURIComponent(obj[cur]), "&");
  }, '');
  return res.length ? res.slice(0, res.length - 1) : res;
}

var apis = {
  //之前的地址：https://cf.jd.com/pages/viewpage.action?pageId=1393150222
  //新的地址：https://joyspace.jd.com/pages/us3NlzOutMEBgJ53qSBM
  getSkuPriceInfo: function getSkuPriceInfo(params) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return requestPost('/common/sku/price/info', params);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // https://cf.jd.com/pages/viewpage.action?pageId=1393149840
  priceCurve: function priceCurve() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var params, _params$priceTypes, priceTypes, needRemoveFive;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              _params$priceTypes = params.priceTypes, priceTypes = _params$priceTypes === void 0 ? [] : _params$priceTypes;
              needRemoveFive = priceTypes.includes(4) || priceTypes.includes(9);
              _context2.next = 5;
              return requestPost('/common/sku/price/image', _objectSpread2(_objectSpread2({}, params), {}, {
                priceTypes: priceTypes.filter(function (item) {
                  return !needRemoveFive || item !== 5;
                })
              }));

            case 5:
              return _context2.abrupt("return", _context2.sent);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  //https://joyspace.jd.com/h/personal/pages/k6ueIaSmp7QRrbR4t0RK
  thresholdPriceCurve: function thresholdPriceCurve() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var params;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              _context3.next = 3;
              return requestPost('/common/sku/price/coupon/image', params);

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  //https://joyspace.jd.com/h/personal/pages/MVG4S4nCiA67MeJmozAE
  promotionInfo: function promotionInfo() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var params;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              params = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
              _context4.next = 3;
              return requestPost('/common/sku/promotion/info', params);

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};

var css_248z$4 = ".TY_copy-icon{cursor:pointer}.TY_copy-icon.small{width:12px;height:12px;margin-left:4px}.TY_copy-icon.middle{width:16px;height:16px;margin-left:6px}.TY_copy-text{color:inherit;display:-webkit-inline-flex;display:inline-flex;-webkit-align-items:center;align-items:center;line-height:1}.TY_copy-text.small{font-size:12px}.TY_copy-text.middle{font-size:14px}";
styleInject(css_248z$4);

var DefaultIcon$1 = (function (props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size === 'middle' ? 16 : 12,
    height: size === 'middle' ? 16 : 12,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 19L4.11662 18.9933C4.5757 18.9399 4.93995 18.5757 4.99327 18.1166L5 18V5H18L18.1166 4.99327C18.614 4.93551 19 4.51284 19 4C19 3.48716 18.614 3.06449 18.1166 3.00673L18 3H4L3.88338 3.00673C3.4243 3.06005 3.06005 3.4243 3.00673 3.88338L3 4V18L3.00673 18.1166C3.06005 18.5757 3.4243 18.9399 3.88338 18.9933L4 19ZM20 21L20.1166 20.9933C20.5757 20.94 20.94 20.5757 20.9933 20.1166L21 20V8L20.9933 7.88338C20.9444 7.46255 20.6343 7.12142 20.2293 7.02641L20.1166 7.00673L20 7H8L7.88338 7.00673C7.4243 7.06005 7.06005 7.4243 7.00673 7.88338L7 8V20L7.00673 20.1166C7.05561 20.5374 7.36575 20.8786 7.77071 20.9736L7.88338 20.9933L8 21H20ZM9 9V19H19V9H9Z",
    fill: "currentcolor"
  }));
});

function copy(value) {
  var input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', value);
  input.select();
  var copyLine = document.execCommand('copy');
  document.body.removeChild(input);
  return copyLine;
}

var Copy = function Copy(_ref) {
  var text = _ref.text,
      children = _ref.children,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'middle' : _ref$size,
      iconStyle = _ref.iconStyle,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? /*#__PURE__*/React.createElement(DefaultIcon$1, {
    size: size
  }) : _ref$icon,
      _ref$clickChildCanCop = _ref.clickChildCanCopy,
      clickChildCanCopy = _ref$clickChildCanCop === void 0 ? false : _ref$clickChildCanCop;
  if (!text && !children) return null;
  var copyedContent = text && children ? text : text || children;
  var copyedChildren = text && children ? children : text || children;
  if (typeof copyedChildren !== 'string' && !text) return children || null;
  var classNames = classnames(_defineProperty({
    className: className
  }, "TY_copy-text ".concat(size), true));

  function handlerCopy(ev) {
    ev.stopPropagation();
    ev.preventDefault();
    if (!copyedContent) return;

    try {
      copy(copyedContent);
      message.success('复制成功');
    } catch (ex) {
      console.error('复制失败', ex);
      message.error('复制失败');
    }
  }

  return /*#__PURE__*/React.createElement("span", {
    className: classNames
  }, clickChildCanCopy ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "\u70B9\u6211\u590D\u5236"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handlerCopy,
    className: classNames
  }, /*#__PURE__*/React.createElement(React.Fragment, null, copyedChildren), /*#__PURE__*/React.createElement("span", {
    className: "TY_copy-icon ".concat(size),
    style: iconStyle
  }, icon)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, copyedChildren), /*#__PURE__*/React.createElement(Tooltip, {
    title: "\u70B9\u6211\u590D\u5236"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handlerCopy,
    className: "TY_copy-icon ".concat(size),
    style: iconStyle
  }, icon))));
};

var css_248z$3 = ".TY_dongdong{display:-webkit-inline-flex;display:inline-flex;-webkit-align-items:center;align-items:center}.TY_dongdong .TY_dongdong_icon{margin-left:6px;cursor:pointer}.TY_dongdong .TY_dongdong_icon:hover path{fill:#2d64ff}.TY_dongdong .TY_dongdong_name{color:inherit}.TY_dongdong .TY_dongdong_name.size_small{font-size:12px}.TY_dongdong .TY_dongdong_name.size_middle{font-size:14px}";
styleInject(css_248z$3);

var DefaultIcon = (function (props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      otherProps = _objectWithoutProperties(props, ["size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size === 'middle' ? 20 : 16,
    height: size === 'middle' ? 20 : 16,
    viewBox: "0 0 20 20",
    fill: "none",
    className: "TY_dongdong_icon",
    xmlns: "http://www.w3.org/2000/svg"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99994 2C14.7393 2 18 5.46793 18 9.12577C18 11.6 16.4262 13.7931 14.8476 14.7651L14.7251 14.8481L14.6754 14.8819L14.6137 16.1439C14.6137 16.5207 14.2283 16.8522 13.8607 16.9049L13.8032 16.9125L13.7459 16.9162L13.7 16.9125L13.6539 16.9086L13.3782 16.871C12.7272 16.773 11.9298 16.4792 11.2023 16.2306L10.961 16.1439L10.7925 16.0799L10.6585 16.0912C10.4402 16.1063 10.222 16.1176 9.99994 16.1175C5.89138 16.1175 2 13.3975 2 9.12577C2 5.46807 5.43767 2 9.99994 2ZM9.99994 3.66347C6.49629 3.66347 3.682 6.12331 3.682 9.12577C3.682 12.1282 6.49629 14.5881 9.99994 14.5881C10.1262 14.5881 10.2527 14.5843 10.379 14.5767L10.5666 14.5654L10.7696 14.5466C10.8653 14.5353 10.9611 14.5466 11.053 14.5729L11.1218 14.5918L11.2405 14.6407L11.5851 14.7651C12.0944 14.9422 12.5768 15.074 13.0363 15.1681L13.2316 15.2059H13.2546V14.2452C13.2546 14.0267 13.3503 13.8195 13.515 13.6763L13.5648 13.635L13.6184 13.601L13.783 13.4993L13.9323 13.3975C15.4295 12.3654 16.3179 10.8058 16.3179 9.12577C16.3179 6.12346 13.5036 3.66347 9.99994 3.66347ZM14.8476 9.40067C14.9265 9.46402 14.9765 9.55568 14.9865 9.65537C14.9965 9.75507 14.9658 9.85459 14.9011 9.93195C13.7524 11.307 11.9451 12.132 9.98463 12.1281C8.05102 12.1281 6.26281 11.3256 5.11408 9.98087C5.04854 9.90447 5.01656 9.80556 5.02517 9.70594C5.03379 9.60632 5.0823 9.51415 5.16002 9.44974C5.23693 9.38517 5.33693 9.3536 5.43767 9.3621C5.5384 9.37059 5.63148 9.41843 5.69611 9.49493C6.70308 10.6703 8.27313 11.3784 9.98463 11.3747C11.7154 11.3747 13.3044 10.6515 14.3076 9.44974C14.3719 9.37174 14.4654 9.32256 14.5671 9.31333C14.6687 9.30409 14.7698 9.33558 14.8476 9.40067ZM9.80467 7.80726H10.1952C10.2258 7.80726 10.2603 7.80726 10.2909 7.81099L10.4786 7.81859C10.5092 7.81859 10.5398 7.82232 10.5704 7.82232L10.7466 7.83739C11.432 7.89765 11.9144 8.05963 11.9144 8.37225C11.9144 8.7866 11.0568 9.12563 9.99994 9.12577C8.94309 9.12592 8.08544 8.78675 8.08544 8.37225C8.08544 8.07469 8.52965 7.91271 9.16898 7.84499L9.34136 7.82993C9.37198 7.8262 9.39882 7.8262 9.42944 7.82232L9.61319 7.81472C9.67444 7.81099 9.73948 7.81099 9.80467 7.80726ZM6.86015 6.583C7.13577 6.73752 7.22779 7.08401 7.07073 7.35517L6.68777 8.00697C6.52659 8.27188 6.1792 8.36061 5.90739 8.2063C5.63557 8.05198 5.53983 7.71169 5.69231 7.44183L6.07513 6.79018C6.23219 6.51901 6.58438 6.42848 6.86015 6.583ZM13.1781 6.583C13.4384 6.43609 13.7639 6.50768 13.9323 6.74498L13.963 6.79018L14.3459 7.44183C14.503 7.713 14.411 8.0559 14.1353 8.21415C13.875 8.36106 13.5495 8.28947 13.3809 8.05217L13.3503 8.00697L12.9675 7.35517C12.8104 7.08401 12.9025 6.74111 13.1781 6.583Z",
    fill: "currentcolor"
  }));
});

var DongDong = (function (props) {
  var _props$erp = props.erp,
      erp = _props$erp === void 0 ? '' : _props$erp,
      _props$name = props.name,
      name = _props$name === void 0 ? '' : _props$name,
      _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      _props$group = props.group,
      group = _props$group === void 0 ? '' : _props$group;
  return /*#__PURE__*/React.createElement("span", {
    className: "TY_dongdong"
  }, /*#__PURE__*/React.createElement("span", {
    className: "TY_dongdong_name size_".concat(size)
  }, name), (erp || group) && /*#__PURE__*/React.createElement(DefaultIcon, {
    size: size,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      erp ? window.location.href = "timline://chat/?topin=".concat(erp) : window.location.href = "timline://chat/?topin=".concat(group, "&type=2");
    }
  }));
});

var Item$1 = function Item(_ref) {
  var title = _ref.title,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      mainData = _ref.mainData,
      flag = _ref.flag,
      isSignUp = _ref.isSignUp,
      priceType = _ref.priceType,
      urlParams = _ref.urlParams,
      logLocation = _ref.logLocation,
      childPriceType = _ref.childPriceType;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      exhibit = _useState2[0],
      setExhibit = _useState2[1];

  var handleExhabit = function handleExhabit() {
    setExhibit(!exhibit);
    window.log && window.log('yx_center_commonprice', 'detail_expand', "{\"priceType\":".concat(priceType, ",\"position\":").concat(logLocation, ",\"lineType\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.lineType, ",\"uniId\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.uniId));
  };

  var getPromoType = function getPromoType(promoType, subPromoType) {
    if (promoType === 1) {
      if (subPromoType === 1) return '单品促销';
    }

    if (promoType === 2) {
      switch (subPromoType) {
        case 1:
          return '总价促销';

        case 2:
          return '套装促销';

        case 3:
          return '赠品促销';

        case 4:
          return '折扣促销';

        case 5:
          return '礼金促销';

        case 9:
          return '官方立减';
      }
    }

    if (promoType === 3 || promoType === 12) {
      switch (subPromoType) {
        case 2:
          return '限品类券';

        case 3:
          return '店铺券';

        case 4:
          return '店铺限品类券';
      }
    }

    return '-';
  };

  var renderBatchExtMap = function renderBatchExtMap(record) {
    var jdShareRatio = record.jdShareRatio,
        venderShareRatio = record.venderShareRatio,
        shareTypeText = record.shareTypeText;
    if (!shareTypeText) return '-';
    if (jdShareRatio === '100') return shareTypeText;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, shareTypeText, /*#__PURE__*/React.createElement("br", null), jdShareRatio && /*#__PURE__*/React.createElement(React.Fragment, null, "\u90E8\u95E8\u627F\u62C5\uFF1A", jdShareRatio + '%'), /*#__PURE__*/React.createElement("br", null), venderShareRatio && /*#__PURE__*/React.createElement(React.Fragment, null, "\u5546\u5BB6\u627F\u62C5\uFF1A", venderShareRatio + '%'))
    }, shareTypeText);
  };

  var getPrice = function getPrice(flag, isMainData, price) {
    //如果点击的是子曲线 就不展示价格
    if (childPriceType) return '';

    if (flag === 'redPrice') {
      return isMainData ? /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: '16px',
          fontWeight: 'bold'
        }
      }, price) : '¥' + price;
    } else {
      return isMainData ? /*#__PURE__*/React.createElement("span", {
        className: "BYBT_red",
        style: {
          fontSize: '16px',
          fontWeight: 'bold'
        }
      }, mainData) : '-' + '¥' + price;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '10px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween",
    style: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: handleExhabit
  }, getPrice(flag, true, mainData), list.length > 0 && (exhibit ? /*#__PURE__*/React.createElement(CaretUpOutlined, null) : /*#__PURE__*/React.createElement(CaretDownOutlined, null)))), exhibit && /*#__PURE__*/React.createElement("div", {
    className: "calculate-card-border"
  }, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "BYBT_flexBetween"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-title BYBT_ellipsis-1-line"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: (item === null || item === void 0 ? void 0 : item.activityName) || '-'
    }, (item === null || item === void 0 ? void 0 : item.activityName) || '-')), /*#__PURE__*/React.createElement("div", null, item !== null && item !== void 0 && item.activityPrice ? getPrice(flag, false, item === null || item === void 0 ? void 0 : item.activityPrice) : '')), /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6D3B\u52A8\u7C7B\u578B\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, getPromoType(item === null || item === void 0 ? void 0 : item.activityType, item === null || item === void 0 ? void 0 : item.subActivityType) || '-')), (item === null || item === void 0 ? void 0 : item.activityInfo) && flag !== 'redPrice' && /*#__PURE__*/React.createElement("div", {
      className: "label BYBT_ellipsis-1-line"
    }, "\u4F18\u60E0\u5F62\u5F0F\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: (item === null || item === void 0 ? void 0 : item.activityInfo) || '-'
    }, (item === null || item === void 0 ? void 0 : item.activityInfo) || '-'))), /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6D3B\u52A8\u7F16\u53F7\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item !== null && item !== void 0 && item.activityId ? /*#__PURE__*/React.createElement(Copy, {
      text: (item === null || item === void 0 ? void 0 : item.activityId) || '-',
      size: "small"
    }) : '-'), isSignUp && /*#__PURE__*/React.createElement("span", {
      className: "BYBT_gray"
    }, "\uFF08\u4EC5\u652F\u6301\u91C7\u9500/\u7C7B\u76EE\u8FD0\u8425\u67E5\u8BE2\uFF09")), /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u4F18\u60E0\u65F6\u95F4\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, (item === null || item === void 0 ? void 0 : item.activityBeginTime) || '-', " - ", (item === null || item === void 0 ? void 0 : item.activityEndTime) || '-')), (item === null || item === void 0 ? void 0 : item.shareTypeText) && !isSignUp && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6210\u672C\u5206\u644A\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, renderBatchExtMap(item) || '-')), !isSignUp && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6D3B\u52A8\u54A8\u8BE2\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item !== null && item !== void 0 && item.activityContact ? /*#__PURE__*/React.createElement(DongDong, {
      name: item === null || item === void 0 ? void 0 : item.activityContact,
      erp: (item === null || item === void 0 ? void 0 : item.activityContact) || '-',
      size: "small"
    }) : '-')), index < list.length - 1 && /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: '10px 0'
      }
    }));
  })));
};

var redPriceTip = '商品扣减单品促销以后的价格，是计算到手价的基准价格。';
var realHandOnPrice = '当前活动/资源位可直接享受的普适性优惠到手价。';
var realRedPrice = '活动用户当前可直接享受的普适性优惠红字价。';
var line4Title = '对应日期，多个成交价中出现最多的普惠成交价。成交价取自商品成交订单，由于原订单可能由多个商品组合优惠下单，因此无具体活动优惠金额展示。';
var line5Title = '对应日期，多个成交价中出现的最低普惠成交价。成交价取自商品成交订单，由于原订单可能由多个商品组合优惠下单，因此无具体活动优惠金额展示。';
var line1Title = '在指定时间周期内，出现的最低的单品单件普惠到手价。该价格结合算法剔除部分低价极值后，计算为近N天最低普惠到手价。';

var PricePathContent$1 = function PricePathContent(_ref) {
  var _data$avgPriceInfoVO, _data$avgPriceInfoVO2, _data$avgPriceInfoVO3, _data$avgPriceInfoVO4, _data$redPriceInfoVO, _data$redPriceInfoVO2, _data$redPriceInfoVO3, _data$redPriceInfoVO4, _data$promoInfoVO, _data$promoInfoVO2, _data$promoInfoVO3, _data$promoInfoVO4, _data$preferentialInf, _data$preferentialInf2, _data$preferentialInf3, _data$preferentialInf4, _data$avgPriceInfoVO5, _data$avgPriceInfoVO6;

  var _ref$lowestPrice = _ref.lowestPrice,
      lowestPrice = _ref$lowestPrice === void 0 ? false : _ref$lowestPrice,
      name = _ref.name,
      days = _ref.days,
      date = _ref.date,
      priceType = _ref.priceType,
      skuId = _ref.skuId,
      rfid = _ref.rfid,
      bidPrice = _ref.bidPrice,
      visible = _ref.visible,
      childPriceType = _ref.childPriceType,
      priceValue = _ref.priceValue;
      _ref.flag;
      var urlParams = _ref.urlParams,
      hisDate = _ref.hisDate,
      isSignUp = _ref.isSignUp,
      biddingId = _ref.biddingId;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var typeMap = new Map([[1, '近N天最低普惠到手价'], [2, '近N天平均普惠到手价'], [3, '近N天平均普惠红字价'], [4, '近N天平均成交价'], [6, '实时普惠到手价'], [7, '实时普惠红字价'], [8, '预估到手价']]); // 是否实时

  var isReal = useMemo(function () {
    return priceType == 6 || priceType == 7 || priceType == 8;
  }, [priceType]);
  var isDoubleLine = [9, 4].includes(Number(priceType)); // 双线的时间格式只有年月日

  useEffect(function () {
    if (isReal) {
      if (!visible) return;
      window.log && window.log('yx_center_commonprice', 'first_expo', "{\"priceType\":".concat(priceType, ",\"lineType\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.lineType, ",\"uniId\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.uniId));
    }
  }, [isReal, visible, priceType, urlParams]); // 主接口

  useEffect(function () {
    if (!priceType || !visible) return;
    getPriceDetail();

    function getPriceDetail() {
      return _getPriceDetail.apply(this, arguments);
    }

    function _getPriceDetail() {
      _getPriceDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var paramObj, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                paramObj = {
                  biddingId: biddingId,
                  priceType: priceType,
                  skuId: skuId,
                  days: days,
                  date: date,
                  childPriceType: childPriceType,
                  hisDate: hisDate
                };

                if (Number(priceType) === 8) {
                  //rfid是对应 skuId的报名id （applyWareId）,只有在priceType为8时，才传（审核弹窗中，点击查看 ‘预估到手价’ 详情等此类场景）
                  if (rfid) paramObj.rfid = rfid; //bidPrice是竞拍价格，只有在报名且priceType为8时，才传竞拍价格

                  if (bidPrice) paramObj.bidPrice = bidPrice; //只有在priceType为8时，uniId为收品池id（areaId）

                  if (urlParams !== null && urlParams !== void 0 && urlParams.uniId) paramObj.areaId = urlParams === null || urlParams === void 0 ? void 0 : urlParams.uniId;
                }

                _context.next = 6;
                return apis.getSkuPriceInfo(paramObj);

              case 6:
                res = _context.sent;

                if (res.success && res.data) {
                  setData(_objectSpread2({}, res.data));
                } else {
                  console.error(res.msg);
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);

              case 13:
                setLoading(false);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));
      return _getPriceDetail.apply(this, arguments);
    }
  }, [biddingId, priceType, date, visible, childPriceType, hisDate]);

  var getTipTitle = function getTipTitle() {
    if ([4, 9].includes(Number(priceType)) && Number(childPriceType) === 1) {
      return line4Title;
    } else if ([4, 9].includes(Number(priceType)) && Number(childPriceType) === 2) {
      return line5Title;
    }

    if (lowestPrice) {
      return line1Title;
    } else {
      return '';
    }
  }; // 只有最低普惠到手价 展示初始值


  if (lowestPrice && priceType != 1 && !isReal) return null;
  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexCenter"
  }, /*#__PURE__*/React.createElement(Spin, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, (priceType == 6 || priceType == 8) && (data === null || data === void 0 ? void 0 : (_data$avgPriceInfoVO = data.avgPriceInfoVO) === null || _data$avgPriceInfoVO === void 0 ? void 0 : _data$avgPriceInfoVO.minHappendt) && /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'rgba(0,0,0,0.65)',
      marginBottom: '10px'
    }
  }, "\u65E5\u671F\uFF1A", data === null || data === void 0 ? void 0 : (_data$avgPriceInfoVO2 = data.avgPriceInfoVO) === null || _data$avgPriceInfoVO2 === void 0 ? void 0 : _data$avgPriceInfoVO2.minHappendt), !isReal ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      marginTop: '15px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, lowestPrice ? '最低普惠到手价' : name, (lowestPrice || [4, 5, 9].includes(priceType)) && /*#__PURE__*/React.createElement(IconTip, {
    title: getTipTitle()
  }), /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.45)'
    }
  }, lowestPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, "\u6700\u4F4E\u4EF7\u65E5\u671F\uFF1A", hisDate || '-') : /*#__PURE__*/React.createElement(React.Fragment, null, "\u65E5\u671F\uFF1A", isDoubleLine ? hisDate.slice(0, 10) : hisDate)), (data === null || data === void 0 ? void 0 : (_data$avgPriceInfoVO3 = data.avgPriceInfoVO) === null || _data$avgPriceInfoVO3 === void 0 ? void 0 : _data$avgPriceInfoVO3.orderId) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.45)'
    }
  }, "\u6D89\u53CA\u8BA2\u5355\u53F7\uFF1A", /*#__PURE__*/React.createElement(Copy, {
    text: data === null || data === void 0 ? void 0 : (_data$avgPriceInfoVO4 = data.avgPriceInfoVO) === null || _data$avgPriceInfoVO4 === void 0 ? void 0 : _data$avgPriceInfoVO4.orderId
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '20px',
      fontWeight: 'bold'
    }
  }, "\xA5 ", priceValue || '-'))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '10px 0'
    }
  })) : '', Number(priceType) === 8 ? /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '20px'
    }
  }, "\u7ADE\u62CD\u4EF7\u683C"), /*#__PURE__*/React.createElement("div", null, "\xA5 ".concat((data === null || data === void 0 ? void 0 : data.bidPrice) || '-'))) : /*#__PURE__*/React.createElement(Item$1, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "\u7EA2\u5B57\u4EF7", /*#__PURE__*/React.createElement(IconTip, {
      title: redPriceTip
    })),
    list: data !== null && data !== void 0 && (_data$redPriceInfoVO = data.redPriceInfoVO) !== null && _data$redPriceInfoVO !== void 0 && _data$redPriceInfoVO.redPriceDetail ? [data === null || data === void 0 ? void 0 : (_data$redPriceInfoVO2 = data.redPriceInfoVO) === null || _data$redPriceInfoVO2 === void 0 ? void 0 : _data$redPriceInfoVO2.redPriceDetail] : [],
    mainData: [4, 5].includes(priceType) && !(data !== null && data !== void 0 && (_data$redPriceInfoVO3 = data.redPriceInfoVO) !== null && _data$redPriceInfoVO3 !== void 0 && _data$redPriceInfoVO3.redPrice) ? '' : '¥' + ((data === null || data === void 0 ? void 0 : (_data$redPriceInfoVO4 = data.redPriceInfoVO) === null || _data$redPriceInfoVO4 === void 0 ? void 0 : _data$redPriceInfoVO4.redPrice) || '-'),
    flag: "redPrice",
    priceType: priceType,
    urlParams: urlParams,
    logLocation: "1",
    childPriceType: childPriceType,
    isSignUp: isSignUp
  }), data !== null && data !== void 0 && data.promoInfoVO ? /*#__PURE__*/React.createElement(Item$1, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "\u4FC3\u9500", ' ', /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: '14px',
        color: 'rgba(0,0,0,0.45)'
      }
    }, "\u5171\u53E0\u52A0", ((data === null || data === void 0 ? void 0 : (_data$promoInfoVO = data.promoInfoVO) === null || _data$promoInfoVO === void 0 ? void 0 : _data$promoInfoVO.promoDetailList) || []).length || '-', "\u4E2A\u4FC3\u9500")),
    list: (data === null || data === void 0 ? void 0 : (_data$promoInfoVO2 = data.promoInfoVO) === null || _data$promoInfoVO2 === void 0 ? void 0 : _data$promoInfoVO2.promoDetailList) || [],
    mainData: [4, 5].includes(priceType) && !(data !== null && data !== void 0 && (_data$promoInfoVO3 = data.promoInfoVO) !== null && _data$promoInfoVO3 !== void 0 && _data$promoInfoVO3.promoPrice) ? '' : '-' + '¥' + ((data === null || data === void 0 ? void 0 : (_data$promoInfoVO4 = data.promoInfoVO) === null || _data$promoInfoVO4 === void 0 ? void 0 : _data$promoInfoVO4.promoPrice) || '-'),
    priceType: priceType,
    urlParams: urlParams,
    logLocation: "2",
    childPriceType: childPriceType,
    isSignUp: isSignUp
  }) : '', data !== null && data !== void 0 && data.preferentialInfoVO ? /*#__PURE__*/React.createElement(Item$1, {
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "\u4F18\u60E0\u5238", ' ', /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: '14px',
        color: 'rgba(0,0,0,0.45)'
      }
    }, "\u5171\u53E0\u52A0", ((data === null || data === void 0 ? void 0 : (_data$preferentialInf = data.preferentialInfoVO) === null || _data$preferentialInf === void 0 ? void 0 : _data$preferentialInf.preferentialDetailList) || []).length || '-', "\u4E2A\u4F18\u60E0\u5238")),
    list: (data === null || data === void 0 ? void 0 : (_data$preferentialInf2 = data.preferentialInfoVO) === null || _data$preferentialInf2 === void 0 ? void 0 : _data$preferentialInf2.preferentialDetailList) || [],
    mainData: [4, 5].includes(priceType) && !(data !== null && data !== void 0 && (_data$preferentialInf3 = data.preferentialInfoVO) !== null && _data$preferentialInf3 !== void 0 && _data$preferentialInf3.preferentialPrice) ? '' : '-' + '¥' + ((data === null || data === void 0 ? void 0 : (_data$preferentialInf4 = data.preferentialInfoVO) === null || _data$preferentialInf4 === void 0 ? void 0 : _data$preferentialInf4.preferentialPrice) || '-'),
    priceType: priceType,
    urlParams: urlParams,
    logLocation: "3",
    childPriceType: childPriceType,
    isSignUp: isSignUp
  }) : '', data !== null && data !== void 0 && data.taxFee ? /*#__PURE__*/React.createElement(Item$1, {
    title: "\u7A0E\u8D39",
    list: [],
    mainData: [4, 5].includes(priceType) && !(data !== null && data !== void 0 && data.taxFee) ? '' : '+' + '¥' + ((data === null || data === void 0 ? void 0 : data.taxFee) || '-'),
    priceType: priceType,
    urlParams: urlParams,
    childPriceType: childPriceType,
    isSignUp: isSignUp
  }) : '', isReal ? /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '20px'
    }
  }, typeMap.get(priceType), /*#__PURE__*/React.createElement(IconTip, {
    title: priceType == 6 ? realHandOnPrice : realRedPrice
  })), /*#__PURE__*/React.createElement("div", null, [4, 5].includes(priceType) && !(data !== null && data !== void 0 && (_data$avgPriceInfoVO5 = data.avgPriceInfoVO) !== null && _data$avgPriceInfoVO5 !== void 0 && _data$avgPriceInfoVO5.price) ? '' : "\xA5 ".concat((data === null || data === void 0 ? void 0 : (_data$avgPriceInfoVO6 = data.avgPriceInfoVO) === null || _data$avgPriceInfoVO6 === void 0 ? void 0 : _data$avgPriceInfoVO6.price) || '-'))) : '');
};

var css_248z$2 = ".calculate-card-border{border:1px solid #e8e8ea;border-radius:6px;padding:10px 14px;font-size:12px;line-height:24px}.calculate-card-border .card-title{color:rgba(0,0,0,.65);font-size:14px;font-weight:700}.calculate-card-border .label{color:rgba(0,0,0,.45)}.calculate-card-border .content{color:#000}.BYBT_flexLeft{-webkit-justify-content:left;justify-content:left}.BYBT_flexCenter,.BYBT_flexLeft{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.BYBT_flexCenter{-webkit-justify-content:center;justify-content:center}.BYBT_flexBetween{display:-webkit-flex;display:flex;-webkit-justify-content:space-between;justify-content:space-between;-webkit-align-items:center;align-items:center}.BYBT_red{color:#ff3b30}.BYBT_blue{color:#007aff;cursor:pointer}.BYBT_yellow{color:#f58b00;cursor:pointer}.BYBT_gray{color:rgba(0,0,0,.25)}";
styleInject(css_248z$2);

var RealPricePath$1 = function RealPricePath(_ref) {
  var children = _ref.children,
      realType = _ref.realType,
      rest = _objectWithoutProperties(_ref, ["children", "realType"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var RealTypeMap = new Map([['RealInclusiveHandPrice', 6], ['RealInclusiveRedPrice', 7], ['RealEstimatedPurchasePrice', 8]]);
  var btn = /*#__PURE__*/React.cloneElement(children, {
    onClick: function onClick() {
      setVisible(true);
    }
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary$1, null, btn, /*#__PURE__*/React.createElement(Modal, {
    forceRender: true,
    title: "\u4EF7\u683C\u8BA1\u7B97\u8BE6\u60C5",
    onCancel: function onCancel() {
      return setVisible(false);
    },
    visible: visible,
    width: 400,
    footer: /*#__PURE__*/React.createElement("div", {
      className: "BYBT_flexCenter"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setVisible(false);
      },
      type: "primary"
    }, "\u6211\u77E5\u9053\u4E86"))
  }, /*#__PURE__*/React.createElement(PricePathContent$1, _extends({
    visible: visible,
    priceType: RealTypeMap.get(realType)
  }, rest))));
};

function ChartView$1(_ref) {
  var visible = _ref.visible,
      days = _ref.days,
      skuId = _ref.skuId,
      urlParams = _ref.urlParams,
      lineMap = _ref.lineMap,
      data = _ref.data,
      chartTitle = _ref.chartTitle,
      chartTitleTip = _ref.chartTitleTip,
      currLineInfo = _ref.currLineInfo,
      chartOnly = _ref.chartOnly,
      date = _ref.date,
      isSignUp = _ref.isSignUp;
  var chartRef = useRef(null);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      timeData = _useState2[0],
      setTimeData = _useState2[1];

  var isDoubleLine = [9, 4].includes(Number(currLineInfo === null || currLineInfo === void 0 ? void 0 : currLineInfo.codeKey));
  var scale = useMemo(function () {
    return {
      value: {
        type: 'linear',
        min: 0,
        formatter: function formatter(v) {
          if (v === null || v === '') return '暂无数据';
          return v;
        }
      },
      name: {
        formatter: function formatter(v) {
          return getLineTitle(v);
        }
      },
      time: {
        tickCount: 120,
        formatter: function formatter(v) {
          if (isDoubleLine) {
            return moment(v).format('YYYY/MM/DD');
          } else {
            return moment(v).format('YYYY/MM/DD HH:mm:ss');
          }
        }
      }
    };
  }, []);

  function getLineTitle(lineName) {
    return lineMap[lineName].chartLine;
  } // 计算最低普惠到手价


  useEffect(function () {
    var _lowestItem;

    if (!data || !data.length) return;
    var lowestItem = data.filter(function (item) {
      return item.name === 'bottomInclusiveHandPrice' && item.value != null;
    });
    if (!((_lowestItem = lowestItem) !== null && _lowestItem !== void 0 && _lowestItem.length)) return;
    lowestItem = lowestItem.reduce(function (total, cur) {
      return cur.value <= total.value ? cur : total;
    });
    if (!lowestItem) return;
    setTimeData(_objectSpread2(_objectSpread2({}, lowestItem), {}, {
      lowestPrice: true
    }));
  }, [data]); // 获取真实的最低成交价的入参
  // 如果是通过最低成交价(5)曲线图，或者通过平均成交价曲线图(4)查询最低成交价那入参 priceType=4
  // 如果是通过严格平均成交价曲线图(9)查询低成交价，priceType=9

  var getTrueButtomPriceType = function getTrueButtomPriceType() {
    if ((currLineInfo === null || currLineInfo === void 0 ? void 0 : currLineInfo.codeKey) === 5) return 4;
    return currLineInfo === null || currLineInfo === void 0 ? void 0 : currLineInfo.codeKey;
  }; // 平均成交价曲线图和严格平均成交价曲线图中的主线childPriceType=1，最低成交价childPriceType=2 其余undefined


  var getChildPriceType = function getChildPriceType(name) {
    switch (name) {
      case 'avgBottomDealPrice':
        return 2;

      case 'avgModeDealPrice':
        return 1;

      case 'strictAvgModeDealPrice':
        return 1;

      default:
        return undefined;
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '15px'
    }
  }, chartTitle, "\u66F2\u7EBF\u56FE", /*#__PURE__*/React.createElement(IconTip, {
    title: chartTitleTip,
    placement: "bottom"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#f5f5f5',
      borderRadius: '5px',
      padding: '10px 5px 5px 10px'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    scale: scale,
    padding: [30, 20, 60, 40],
    autoFit: true,
    height: 260,
    data: data,
    ref: chartRef,
    onGetG2Instance: function onGetG2Instance(c) {
      c.removeInteraction('legend-filter');
    }
  }, /*#__PURE__*/React.createElement(Axis, {
    name: "time",
    label: {
      style: {
        textAlign: 'center'
      },
      offset: 6,
      formatter: function formatter(text, item, index) {
        if (isDoubleLine) {
          // 双线去掉时分秒
          return text.slice(0, 10);
        } else {
          return "".concat(text.slice(0, 10), "\n").concat(text.slice(11, 20));
        }
      }
    }
  }), /*#__PURE__*/React.createElement(Line, {
    shape: "smooth",
    position: "time*value",
    color: "name"
  }), /*#__PURE__*/React.createElement(Point, {
    position: "time*value",
    color: "name"
  }), /*#__PURE__*/React.createElement(Tooltip$1, {
    shared: true,
    lock: true,
    enterable: true,
    showMarkers: true,
    showCrosshairs: true
  }, function (title, items, value) {
    return /*#__PURE__*/React.createElement("div", {
      className: "custom-tooltip-wrapper",
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-tooltip-title"
    }, title), /*#__PURE__*/React.createElement("ul", {
      className: "g2-tooltip-list"
    }, (items || []).map(function (it, index) {
      var color = it.color,
          _it$data = it.data;
          _it$data.dept;
          var name = _it$data.name,
          value = it.value;
      return /*#__PURE__*/React.createElement("li", {
        className: "g2-tooltip-list-item",
        key: name
      }, /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-marker",
        style: {
          background: color
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-name"
      }, value === '暂无数据' || chartOnly ? getLineTitle(name) : /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          setTimeData(it === null || it === void 0 ? void 0 : it.data);
          window.log && window.log('yx_center_commonprice', 'price_button', "{\"priceType\":".concat(currLineInfo === null || currLineInfo === void 0 ? void 0 : currLineInfo.codeKey, ",\"lineType\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.lineType, ",\"uniId\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.uniId, ","));
        }
      }, getLineTitle(name))), /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-value"
      }, value));
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'rgba(0,0,0,0.25)'
      }
    }, "\u70B9\u51FB\u4EF7\u683C\u6807\u7B7E\u4EE5\u67E5\u770B\u8BE6\u60C5"));
  }), /*#__PURE__*/React.createElement(Legend, {
    position: "top-left",
    fill: "white",
    clickable: true,
    onChange: function onChange() {},
    marker: {
      symbol: 'hyphen'
    }
  }), /*#__PURE__*/React.createElement(Interaction, {
    type: "active-region"
  }), /*#__PURE__*/React.createElement(Slider, {
    height: 14,
    textStyle: {
      fill: '#989EA5'
    },
    foregroundStyle: {
      fill: '#0F2764'
    },
    padding: [0, 0, 0, 0],
    handlerStyle: {
      style: {
        fill: '#6B7180'
      }
    }
  }))), !chartOnly && timeData.time && /*#__PURE__*/React.createElement(PricePathContent$1, {
    lowestPrice: !!timeData.lowestPrice,
    priceValue: timeData === null || timeData === void 0 ? void 0 : timeData.value,
    skuId: skuId,
    priceType: getTrueButtomPriceType(),
    visible: visible,
    hisDate: timeData === null || timeData === void 0 ? void 0 : timeData.time,
    date: date,
    days: days,
    name: getLineTitle(timeData === null || timeData === void 0 ? void 0 : timeData.name),
    childPriceType: getChildPriceType(timeData === null || timeData === void 0 ? void 0 : timeData.name),
    urlParams: urlParams,
    isSignUp: isSignUp
  }));
}

function Empty1$1(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(Empty, {
    style: {
      marginTop: '100px'
    },
    description: children
  });
}

function FormulaLabel(_ref) {
  var price = _ref.price,
      title = _ref.title,
      formulaText = _ref.formulaText,
      formulaMuText = _ref.formulaMuText,
      accTitleTip = _ref.accTitleTip,
      otherTitleTip = _ref.otherTitleTip,
      fixed = _ref.fixed;
  return /*#__PURE__*/React.createElement(Alert, {
    message: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        color: '#000',
        fontWeight: 'bold'
      }
    }, /*#__PURE__*/React.createElement(IconTip, {
      type: "info",
      filled: true,
      color: "#10abf7"
    }), /*#__PURE__*/React.createElement("div", null, title, /*#__PURE__*/React.createElement(IconTip, {
      title: accTitleTip,
      placement: "bottom"
    }), /*#__PURE__*/React.createElement("span", null, "\xA0 = \xA0")), /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", null, formulaText), /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: '5px',
        borderTop: '1px solid #000'
      }
    }), /*#__PURE__*/React.createElement("div", null, formulaMuText)), !fixed && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "\xA0 = \xA0"), " \xA5 ", price)), /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'rgba(0,0,0,0.25)'
      }
    }, otherTitleTip)),
    type: "info" // showIcon
    ,
    style: {
      margin: '0 auto 15px auto'
    }
  });
}

function ChartLine$1(_ref) {
  var biddingId = _ref.biddingId,
      visible = _ref.visible,
      days = _ref.days,
      skuId = _ref.skuId,
      urlParams = _ref.urlParams,
      _ref$chartTypeList = _ref.chartTypeList,
      chartTypeList = _ref$chartTypeList === void 0 ? [] : _ref$chartTypeList,
      date = _ref.date,
      fixed = _ref.fixed,
      lineMap = _ref.lineMap,
      title = _ref.title,
      chartOnly = _ref.chartOnly,
      isSignUp = _ref.isSignUp,
      filterDate = _ref.filterDate;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineData = _useState2[0],
      setLineData = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      avgPrice = _useState4[0],
      setAvgPrice = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      noError = _useState6[0],
      setNoError = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  useMemo(function () {
    return chartTypeList.map(function (item) {
      return lineMap[item]['codeKey'];
    });
  }, [chartTypeList]);
  var currLineInfo = useMemo(function () {
    return lineMap[chartTypeList[0]];
  }, [chartTypeList]);

  var getName = function getName(name, type) {
    if (name === 'chartLine') {
      var newObj = {};
      Object.keys(lineMap).filter(function (lineName) {
        return chartTypeList.includes(lineName);
      }).forEach(function (lineName) {
        newObj[lineName] = lineMap[lineName][name];
      });
      return newObj;
    } else {
      // type  arraySome 入参的时候传数组，有4不传5
      var newArrayList = chartTypeList.map(function (item) {
        var _lineMap$item;

        return (_lineMap$item = lineMap[item]) === null || _lineMap$item === void 0 ? void 0 : _lineMap$item[name];
      }); // singleEvery 点击的时候 每一个都传

      var newSinleEvery = Array.from(new Set(newArrayList)).join();

      if (type === 'arraySome') {
        return newArrayList;
      } else if (type === 'singleSome') {
        return newArrayList[0];
      } else if (type === 'singleEvery') {
        return newSinleEvery;
      } else {
        return newArrayList;
      }
    }
  };

  useEffect(function () {
    if (!visible) return;
    window.log && window.log('yx_center_commonprice', 'first_expo', "{\"priceType\":".concat(getName('codeKey', 'singleSome'), ",\"lineType\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.lineType, ",\"uniId\":").concat(urlParams === null || urlParams === void 0 ? void 0 : urlParams.uniId));
  }, []);
  useEffect(function () {
    if (!visible) return;
    setLoading(true);
    var params = {
      priceTypes: getName('codeKey', 'arraySome'),
      days: days,
      skuId: skuId,
      date: date,
      filterDate: filterDate,
      biddingId: biddingId
    };
    apis.priceCurve(params).then(function (res) {
      var _res$data, _res$data2;

      var chartData = convertData(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.priceCurveDataList);
      setAvgPrice(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.avgPrice);
      setLineData(chartData);
    });
    setLoading(false);
  }, [days, skuId, visible, chartTypeList]);
  var convertData = useCallback(function (data) {
    var result = (data || []).map(function (item) {
      var filterBox = chartTypeList.map(function (sub) {
        return {
          name: sub,
          time: item.dailyDate,
          value: item[sub] === '' ? null : item[sub]
        };
      });
      return filterBox;
    }).flat();
    var errLine = filteredKeys(data, chartTypeList).join(',');
    errLine && setNoError("\u6682\u65E0".concat(errLine, "\u6570\u636E\uFF0C\u4E4B\u540E\u518D\u6765\u770B\u770B\u5427"));
    return result;
  }, []);

  var filteredKeys = function filteredKeys(data, keyArray) {
    var result = [];

    var _iterator = _createForOfIteratorHelper(keyArray),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;

        if ((data || []).every(function (item) {
          return item[key] === null;
        })) {
          result.push(key);
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var newResult = result.map(function (item) {
      return lineMap[item]['chartLine'];
    });
    return newResult;
  };

  if (loading) return /*#__PURE__*/React.createElement(Spin, null);
  if (lineData.length === 0) return /*#__PURE__*/React.createElement(Empty1$1, null, "\u6682\u65E0", title, "\u6570\u636E\uFF0C\u4E4B\u540E\u518D\u6765\u770B\u770B\u5427\uFF5E");
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!getName('formula', 'singleSome') && /*#__PURE__*/React.createElement(FormulaLabel, {
    fixed: fixed || Boolean(filterDate) // 固定不展示price,指定时间也不展示
    ,
    price: avgPrice,
    title: getName('accTitle', 'singleSome'),
    formulaText: getName('formula', 'singleSome'),
    formulaMuText: getName('formulaMu', 'singleSome'),
    accTitleTip: getName('accTitleTip', 'singleSome'),
    otherTitleTip: getName('otherTitleTip', 'singleSome')
  }), noError && /*#__PURE__*/React.createElement(Alert, {
    message: noError,
    type: "error",
    showIcon: true,
    style: {
      margin: '0 auto 15px'
    }
  }), /*#__PURE__*/React.createElement(ChartView$1, {
    visible: visible,
    days: days,
    skuId: skuId,
    urlParams: urlParams,
    lineMap: lineMap,
    data: lineData,
    currLineInfo: currLineInfo,
    chartTitle: getName('chartTitle', 'singleSome'),
    chartTitleTip: getName('chartTitleTip', 'singleSome'),
    chartOnly: chartOnly,
    date: date,
    isSignUp: isSignUp
  }));
}

function getLineMap(_ref) {
  var fixed = _ref.fixed,
      days = _ref.days,
      filterDate = _ref.filterDate;
  var fixedChartTitle = fixed || filterDate ? '历史' : "\u8FD1".concat(days, "\u5929");
  var fixedChartTitleTip = filterDate ? '指定N天' : fixed ? "\u8FD1N\u5929" : "\u8FD1".concat(days, "\u5929");
  var fixedDrawerTitle = fixed || filterDate ? '' : "\u8FD1".concat(days, "\u5929");
  var commonVal = {
    chartTitle: "".concat(fixedChartTitle, "\u5E73\u5747\u6210\u4EA4\u4EF7\u6838\u5FC3\u8BA1\u7B97\u56E0\u5B50"),
    chartTitleTip: '指该商品在指定时间周期内，每日成交价众数和最低成交价波动变化情况。',
    accTitle: "".concat(fixedChartTitleTip, "\u5E73\u5747\u6210\u4EA4\u4EF7"),
    accTitleTip: '在指定时间周期内，取符合条件的有效订单计算的，普惠成交价。【统计范围】购买商品时（包含凑单），可直接使用的普适性优惠活动的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的促销及优惠券等。',
    drawerTitle: "".concat(fixedDrawerTitle, "\u5E73\u5747\u6210\u4EA4\u4EF7"),
    formula: '历史成交金额A+...+历史成交金额N',
    formulaMu: '总订单内商品数 = 订单A商品数 +...+订单N商品数',
    otherTitleTip: '同时刻的订单受叠加促销影响导致对应成交价各异，曲线仅展示成交价众数和最低成交价相关数据以供参考。'
  };
  var lineMap = {
    bottomInclusiveHandPrice: {
      codeKey: 1,
      chartLine: '到手价',
      chartTitle: "".concat(fixedChartTitle, "\u666E\u60E0\u5230\u624B\u4EF7"),
      chartTitleTip: '指该商品在指定时间周期内的到手价波动变化情况。针对一天内到手价变价多次的场景仅展示了部分关键时间点数据，部分时间段可能因为商品下柜等原因暂无到手价数据。',
      accTitle: "".concat(fixedChartTitleTip, "\u666E\u60E0\u5230\u624B\u4EF7"),
      accTitleTip: '',
      drawerTitle: "".concat(fixedDrawerTitle, "\u6700\u4F4E\u666E\u60E0\u5230\u624B\u4EF7"),
      formula: ''
    },
    avgInclusiveHandPrice: {
      codeKey: 2,
      chartLine: '到手价',
      chartTitle: "".concat(fixedChartTitle, "\u666E\u60E0\u5230\u624B\u4EF7"),
      chartTitleTip: '指该商品在指定时间周期内的到手价波动变化情况。针对一天内到手价变价多次的场景仅展示了部分关键时间点数据，部分时间段可能因为商品下柜等原因暂无到手价数据。',
      accTitle: "".concat(fixedChartTitleTip, "\u5E73\u5747\u666E\u60E0\u5230\u624B\u4EF7"),
      accTitleTip: '在指定时间周期内，按时长加权计算的，单品单件普惠到手价。【统计范围】只购买一件商品时，可直接使用的普适性优惠活动的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的促销及优惠券等。',
      drawerTitle: "".concat(fixedDrawerTitle, "\u5E73\u5747\u666E\u60E0\u5230\u624B\u4EF7"),
      formula: '历史到手价A x 时长A + ... + 历史到手价N x 时长N',
      formulaMu: '总时长 = 时长A + ... + 时长N',
      chartBtnTitle: "".concat(fixedDrawerTitle, "\u5E73\u5747\u666E\u60E0\u5230\u624B\u4EF7"),
      chartBtnDesc: '在指定时间周期内，按时长加权计算的，单品单件普惠到手价。【统计范围】只购买一件商品时，可直接使用的普适性优惠活动的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的促销及优惠券等。'
    },
    avgInclusiveRedPrice: {
      codeKey: 3,
      chartLine: '红字价',
      chartTitle: "".concat(fixedChartTitle, "\u666E\u60E0\u7EA2\u5B57\u4EF7"),
      chartTitleTip: '指该商品在指定时间周期内的红字价波动变化情况。针对一天内红字价变价多次的场景仅展示了部分关键时间点数据，部分时间段可能因为商品下柜等原因暂无红字价数据。',
      accTitle: "".concat(fixedChartTitleTip, "\u5E73\u5747\u666E\u60E0\u7EA2\u5B57\u4EF7"),
      accTitleTip: '在指定时间周期内，按时长加权计算的，单品单件普惠红字价。【统计范围】只购买一件商品时，可直接使用的普适性单品促销的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的单品促销。',
      drawerTitle: "".concat(fixedDrawerTitle, "\u5E73\u5747\u666E\u60E0\u7EA2\u5B57\u4EF7"),
      formula: '历史红字价A x 时长A + ... + 历史红字价N x 时长N',
      formulaMu: '总时长 = 时长A + ... + 时长N',
      chartBtnTitle: "".concat(fixedDrawerTitle, "\u5E73\u5747\u666E\u60E0\u7EA2\u5B57\u4EF7"),
      chartBtnDesc: '在指定时间周期内，按时长加权计算的，单品单件普惠红字价。【统计范围】只购买一件商品时，可直接使用的普适性单品促销的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的单品促销。'
    },
    avgModeDealPrice: {
      codeKey: 4,
      chartLine: '成交价众数',
      chartTitle: commonVal.chartTitle,
      chartTitleTip: commonVal.chartTitleTip,
      accTitle: commonVal.accTitle,
      accTitleTip: commonVal.accTitleTip,
      drawerTitle: commonVal.drawerTitle,
      formula: commonVal.formula,
      formulaMu: commonVal.formulaMu,
      otherTitleTip: commonVal.otherTitleTip
    },
    avgBottomDealPrice: {
      // 这是单独查询最低成交价的config
      codeKey: 5,
      chartLine: '最低成交价',
      chartTitle: "".concat(fixedDrawerTitle, "\u6700\u4F4E\u6210\u4EA4\u4EF7"),
      chartTitleTip: '指该商品在指定时间周期内，最低成交价波动变化情况。',
      accTitle: '',
      accTitleTip: '',
      drawerTitle: "".concat(fixedDrawerTitle, "\u6700\u4F4E\u6210\u4EA4\u4EF7"),
      formula: '',
      formulaMu: '',
      otherTitleTip: ''
    },
    redMarkPrice: {
      codeKey: 8,
      chartLine: '红字价',
      chartTitle: "".concat(fixedChartTitle, "\u7EA2\u5B57\u4EF7"),
      chartTitleTip: '',
      accTitle: "".concat(fixedChartTitleTip, "\u7EA2\u5B57\u4EF7"),
      accTitleTip: '',
      drawerTitle: "".concat(fixedDrawerTitle, "\u7EA2\u5B57\u4EF7"),
      formula: ''
    },
    strictAvgModeDealPrice: {
      codeKey: 9,
      chartLine: '成交价众数',
      chartTitle: '加严版' + commonVal.chartTitle,
      chartTitleTip: commonVal.chartTitleTip,
      accTitle: commonVal.accTitle,
      accTitleTip: '在指定时间周期内，取符合条件的有效订单计算的，普惠成交价。【统计范围】购买商品时（包含凑单），可直接使用的普惠性优惠活动的价格。其中，剔除特殊用户身份价格，以及红包等用户个人支付权益和限制区域或限制身份的、非广泛可用的促销及优惠券等（百补、秒杀、大促等通用促销不会剔除，仍计算在内）。',
      drawerTitle: '加严版' + commonVal.drawerTitle,
      formula: commonVal.formula,
      formulaMu: commonVal.formulaMu,
      otherTitleTip: commonVal.otherTitleTip
    }
  };
  return {
    fixedChartTitle: fixedChartTitle,
    fixedChartTitleTip: fixedChartTitleTip,
    fixedDrawerTitle: fixedDrawerTitle,
    commonVal: commonVal,
    lineMap: lineMap
  };
}

function getLineDescText(_ref2) {
  var fixed = _ref2.fixed,
      days = _ref2.days,
      chartType = _ref2.chartType,
      filterDate = _ref2.filterDate;
  return getLineMap({
    days: days,
    fixed: fixed,
    filterDate: filterDate
  }).lineMap[chartType] || {};
}
function ChartDrawer$1(_ref3) {
  var _lineMap$chartTypeLis;

  var children = _ref3.children,
      days = _ref3.days,
      skuId = _ref3.skuId,
      urlParams = _ref3.urlParams,
      _ref3$chartTypeList = _ref3.chartTypeList,
      chartTypeList = _ref3$chartTypeList === void 0 ? [] : _ref3$chartTypeList,
      date = _ref3.date,
      _ref3$fixed = _ref3.fixed,
      fixed = _ref3$fixed === void 0 ? false : _ref3$fixed,
      _ref3$chartOnly = _ref3.chartOnly,
      chartOnly = _ref3$chartOnly === void 0 ? false : _ref3$chartOnly,
      isSignUp = _ref3.isSignUp,
      filterDate = _ref3.filterDate,
      biddingId = _ref3.biddingId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var lineMap = useMemo(function () {
    return getLineMap({
      days: days,
      fixed: fixed,
      filterDate: filterDate
    }).lineMap;
  }, [days, fixed]); // 合并多条线的drawerTitle
  // const drawerTitle = Array.from(new Set(chartTypeList.map((item: any) => lineMap[item]['drawerTitle']))).join()

  var drawerTitle = (_lineMap$chartTypeLis = lineMap[chartTypeList[0]]) === null || _lineMap$chartTypeLis === void 0 ? void 0 : _lineMap$chartTypeLis.drawerTitle;
  var chartTexts = chartTypeList.map(function (item) {
    return lineMap[item];
  });
  var btn = typeof children === 'function' ? children({
    onClick: function onClick() {
      setVisible(true);
    },
    chartTexts: chartTexts
  }) : /*#__PURE__*/React.cloneElement(children, {
    onClick: function onClick() {
      setVisible(true);
    },
    chartTexts: chartTexts
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, btn, /*#__PURE__*/React.createElement(Drawer, {
    className: "chartline-wrap",
    width: 1100,
    visible: visible,
    title: "".concat(drawerTitle, "\u8BA1\u7B97\u8BE6\u60C5"),
    onClose: function onClose() {
      setVisible(false);
    },
    footer: [/*#__PURE__*/React.createElement(Button, {
      type: "primary",
      key: "a",
      onClick: function onClick() {
        setVisible(false);
      }
    }, "\u6211\u77E5\u9053\u4E86")]
  }, /*#__PURE__*/React.createElement(ChartLine$1, {
    visible: visible,
    days: days,
    skuId: skuId,
    urlParams: urlParams,
    chartTypeList: chartTypeList,
    date: date,
    fixed: fixed,
    lineMap: lineMap,
    title: drawerTitle,
    chartOnly: chartOnly,
    isSignUp: isSignUp,
    filterDate: filterDate,
    biddingId: biddingId
  })));
}

// import DongDong from '../components/dongdong'

function getPriceFormat(price) {
  if (isNaN(price)) return null;
  if (price >= 0) return '￥' + price;
  return '-￥' + -1 * price;
}

var Item = function Item(_ref) {
  var title = _ref.title,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      priceValue = _ref.priceValue;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      exhibit = _useState2[0],
      setExhibit = _useState2[1];

  var handleExhabit = function handleExhabit() {
    setExhibit(!exhibit);
  };

  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '10px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween",
    style: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, title), list.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: "content"
  }, "\u5171\u53E0\u52A0", list.length, "\u4E2A", title)), /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    onClick: handleExhabit
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, getPriceFormat(priceValue)), list.length > 0 && (exhibit ? /*#__PURE__*/React.createElement(CaretUpOutlined, null) : /*#__PURE__*/React.createElement(CaretDownOutlined, null)))), exhibit && /*#__PURE__*/React.createElement("div", {
    className: "calculate-card-border"
  }, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
    console.log(item);
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, index !== 0 && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
      className: "BYBT_flexBetween"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-title BYBT_ellipsis-1-line"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: (item === null || item === void 0 ? void 0 : item.promoName) || '-'
    }, (item === null || item === void 0 ? void 0 : item.promoName) || '-')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, getPriceFormat(item === null || item === void 0 ? void 0 : item.priceValue)))), item.promoDegree && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u4F18\u60E0\u5F62\u5F0F\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item.promoDegree)), item.subPromoTypeName && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6D3B\u52A8\u7C7B\u578B\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item.subPromoTypeName)), Boolean(item.promoId) && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u6D3B\u52A8\u7F16\u53F7\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item.promoId)), item.validTime && /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, "\u4F18\u60E0\u65F6\u95F4\uFF1A", /*#__PURE__*/React.createElement("span", {
      className: "content"
    }, item.validTime)));
  })));
};

var PricePathContent = function PricePathContent(_ref) {
  var _ref$showLowestPrice = _ref.showLowestPrice,
      showLowestPrice = _ref$showLowestPrice === void 0 ? false : _ref$showLowestPrice,
      name = _ref.name,
      visible = _ref.visible,
      priceValue = _ref.priceValue,
      hisDate = _ref.hisDate,
      _ref$promoPriceInfo = _ref.promoPriceInfo,
      promoPriceInfo = _ref$promoPriceInfo === void 0 ? {} : _ref$promoPriceInfo,
      skuId = _ref.skuId;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; // 主接口


  useEffect(function () {
    if (!visible) return;
    getPriceDetail();

    function getPriceDetail() {
      return _getPriceDetail.apply(this, arguments);
    }

    function _getPriceDetail() {
      _getPriceDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return apis.promotionInfo({
                  promoPriceInfo: promoPriceInfo,
                  skuId: skuId
                });

              case 4:
                res = _context.sent;

                if (res !== null && res !== void 0 && res.success && res !== null && res !== void 0 && res.data) {
                  setData(res.data);
                } else {
                  console.error(res === null || res === void 0 ? void 0 : res.msg);
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);

              case 11:
                setLoading(false);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return _getPriceDetail.apply(this, arguments);
    }
  }, [visible, skuId, promoPriceInfo]);
  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexCenter"
  }, /*#__PURE__*/React.createElement(Spin, null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      marginTop: '15px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "BYBT_flexBetween"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, showLowestPrice ? "\u6700\u4F4E".concat(name) : name, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.45)'
    }
  }, showLowestPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, "\u6700\u4F4E\u4EF7\u65E5\u671F\uFF1A", hisDate || '-') : /*#__PURE__*/React.createElement(React.Fragment, null, "\u65E5\u671F\uFF1A", hisDate)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '20px',
      fontWeight: 'bold'
    }
  }, "\xA5 ", priceValue || '-'))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '10px 0'
    }
  }), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item, {
      key: index,
      title: item.promoTypeName,
      list: item.subPromotions,
      priceValue: item.priceValue
    });
  }));
};

var css_248z$1 = ".fix-tooltip-wrapper{background-color:#fff;box-shadow:0 0 10px #aeaeae;color:#595959;font-size:12px;z-index:8;border-radius:3px;line-height:22px;padding:10px 22px;opacity:.95;pointer-events:auto}.fix-tooltip-wrapper .fix-tooltip-marker{background:#5b8ff9;width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px}.fix-tooltip-wrapper .fix-tooltip-name{color:#5b8ff9}.fix-tooltip-wrapper .fix-tooltip-value{margin-left:30px}";
styleInject(css_248z$1);

function ChartView(_ref) {
  var visible = _ref.visible,
      data = _ref.data,
      chartTitle = _ref.chartTitle,
      chartTitleTip = _ref.chartTitleTip,
      chartOnly = _ref.chartOnly,
      skuId = _ref.skuId;
  var chartRef = useRef(null);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      timeData = _useState2[0],
      setTimeData = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      initToolTipShow = _useState4[0],
      setInitToolTipShow = _useState4[1];

  var scale = useMemo(function () {
    return {
      value: {
        type: 'linear',
        min: 0,
        formatter: function formatter(v) {
          if (v === null || v === '') return '暂无数据';
          return v;
        }
      },
      time: {
        tickCount: 120,
        formatter: function formatter(v) {
          return moment(v).format('YYYY/MM/DD HH:mm:ss');
        }
      }
    };
  }, []); // 计算最低价

  useEffect(function () {
    var _lowestItem;

    if (!data || !data.length) return;
    var lowestItem = data.filter(function (item) {
      return item.value != null;
    });
    if (!((_lowestItem = lowestItem) !== null && _lowestItem !== void 0 && _lowestItem.length)) return;
    lowestItem = lowestItem.reverse().reduce(function (total, cur) {
      return cur.value <= total.value ? cur : total;
    });
    if (!lowestItem) return;
    setInitToolTipShow(true);
    setTimeData(_objectSpread2(_objectSpread2({}, lowestItem), {}, {
      showLowestPrice: true
    }));
  }, [data]);
  useEffect(function () {
    if (!visible) {
      setTimeData({});
    }
  }, [visible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '15px'
    }
  }, chartTitle, "\u66F2\u7EBF\u56FE", /*#__PURE__*/React.createElement(IconTip, {
    title: chartTitleTip,
    placement: "bottom"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#f5f5f5',
      borderRadius: '5px',
      padding: '10px 5px 5px 10px'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    scale: scale,
    padding: [30, 20, 60, 40],
    autoFit: true,
    height: 260,
    data: data,
    ref: chartRef,
    onGetG2Instance: function onGetG2Instance(c) {
      c.removeInteraction('legend-filter');
    },
    onTooltipChange: function onTooltipChange() {
      setInitToolTipShow(false);
    }
  }, /*#__PURE__*/React.createElement(Axis, {
    name: "time",
    label: {
      style: {
        textAlign: 'center'
      },
      offset: 6,
      formatter: function formatter(text, item, index) {
        return "".concat(text.slice(0, 10), "\n").concat(text.slice(11, 20));
      }
    }
  }), /*#__PURE__*/React.createElement(Line, {
    shape: "hv",
    position: "time*value",
    color: "name"
  }), /*#__PURE__*/React.createElement(Point, {
    position: "time*value",
    color: "name"
  }), /*#__PURE__*/React.createElement(Tooltip$1, {
    shared: true,
    lock: true,
    enterable: true,
    showMarkers: true,
    showCrosshairs: true
  }, function (title, items, value) {
    return /*#__PURE__*/React.createElement("div", {
      className: "custom-tooltip-wrapper",
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-tooltip-title"
    }, title), /*#__PURE__*/React.createElement("ul", {
      className: "g2-tooltip-list"
    }, (items || []).map(function (it, index) {
      var color = it.color,
          _it$data = it.data;
          _it$data.dept;
          var name = _it$data.name,
          value = it.value;
      return /*#__PURE__*/React.createElement("li", {
        className: "g2-tooltip-list-item",
        key: name
      }, /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-marker",
        style: {
          background: color
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-name"
      }, value === '暂无数据' || chartOnly ? name : /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          setTimeData(it === null || it === void 0 ? void 0 : it.data);
        },
        clstag: "pageclick|keycount|yx_shop_pricecheck_1725353317190|1"
      }, name)), /*#__PURE__*/React.createElement("span", {
        className: "g2-tooltip-value"
      }, value));
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'rgba(0,0,0,0.25)'
      }
    }, "\u70B9\u51FB\u4EF7\u683C\u6807\u7B7E\u4EE5\u67E5\u770B\u8BE6\u60C5"));
  }), /*#__PURE__*/React.createElement(Legend, {
    position: "top-left",
    fill: "white",
    clickable: true,
    onChange: function onChange() {},
    marker: {
      symbol: 'hyphen'
    }
  }), /*#__PURE__*/React.createElement(Interaction, {
    type: "active-region"
  }), /*#__PURE__*/React.createElement(Slider, {
    height: 14,
    textStyle: {
      fill: '#989EA5'
    },
    foregroundStyle: {
      fill: '#0F2764'
    },
    padding: [0, 0, 0, 0],
    handlerStyle: {
      style: {
        fill: '#6B7180'
      }
    }
  }), timeData.showLowestPrice && initToolTipShow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Annotation.Html, {
    position: [timeData.time, timeData.value],
    offsetY: 15,
    html: "<div class=\"fix-tooltip-wrapper\"><div className=\"fix-tooltip-title\">".concat(timeData.time, "</div><li style=\"list-style-type: none;\" class=\"fix-tooltip-list-item\"><span class=\"fix-tooltip-marker\"></span><span class=\"fix-tooltip-name\">\u6700\u4F4E").concat(timeData.name, "</span><span class=\"fix-tooltip-value\">").concat(timeData.value, "</span></li><div style={{ color: 'rgba(0,0,0,0.25)' }}>\u70B9\u51FB\u4EF7\u683C\u6807\u7B7E\u4EE5\u67E5\u770B\u8BE6\u60C5</div></div>")
  }), /*#__PURE__*/React.createElement(Annotation.DataMarker, {
    position: [timeData.time, timeData.value],
    text: {
      content: ''
    }
  })))), !chartOnly && timeData.time && timeData.promoPriceInfo && /*#__PURE__*/React.createElement(PricePathContent, {
    promoPriceInfo: timeData.promoPriceInfo // 价格路径接口入参
    ,
    showLowestPrice: !!timeData.showLowestPrice //是否默认展示最低价
    ,
    priceValue: timeData === null || timeData === void 0 ? void 0 : timeData.value //当前展示价格
    ,
    visible: visible,
    hisDate: timeData === null || timeData === void 0 ? void 0 : timeData.time //当前展示时间
    ,
    name: timeData === null || timeData === void 0 ? void 0 : timeData.name //当前曲线名称
    ,
    skuId: skuId
  }));
}

function Empty1(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(Empty, {
    style: {
      marginTop: '100px'
    },
    description: children
  });
}

function ChartLine(_ref) {
  var visible = _ref.visible,
      skuId = _ref.skuId,
      chartType = _ref.chartType,
      lineMap = _ref.lineMap,
      title = _ref.title,
      chartOnly = _ref.chartOnly,
      promoPrice = _ref.promoPrice,
      areaId = _ref.areaId,
      batchId = _ref.batchId,
      activityDuration = _ref.activityDuration,
      newGiftType = _ref.newGiftType;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineData = _useState2[0],
      setLineData = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      noError = _useState4[0];
      _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var getName = function getName(name) {
    var _lineMap$chartType;

    return (_lineMap$chartType = lineMap[chartType]) === null || _lineMap$chartType === void 0 ? void 0 : _lineMap$chartType[name];
  };

  useEffect(function () {
    if (!visible) return;
    setLoading(true);
    var params = {
      type: getName('codeKey'),
      promoPrice: promoPrice,
      areaId: areaId,
      batchId: batchId,
      activityDuration: activityDuration,
      skuId: skuId,
      newGiftType: newGiftType
    };
    apis.thresholdPriceCurve(params).then(function (res) {

      var chartData = convertData(res === null || res === void 0 ? void 0 : res.data.priceValues);
      setLineData(chartData);
    });
    setLoading(false);
  }, [skuId, visible, chartType]);
  var convertData = useCallback(function (data) {
    var result = (data || []).map(function (item) {
      var _lineMap$item$type;

      return _objectSpread2({
        name: (_lineMap$item$type = lineMap[item.type]) === null || _lineMap$item$type === void 0 ? void 0 : _lineMap$item$type.chartLine,
        time: item.beginTime
      }, item);
    });
    return result;
  }, []);
  if (loading) return /*#__PURE__*/React.createElement(Spin, null);
  if (lineData.length === 0) return /*#__PURE__*/React.createElement(Empty1, null, "\u6682\u65E0", title, "\u6570\u636E\uFF0C\u4E4B\u540E\u518D\u6765\u770B\u770B\u5427\uFF5E");
  return /*#__PURE__*/React.createElement(React.Fragment, null, noError && /*#__PURE__*/React.createElement(Alert, {
    message: noError,
    type: "error",
    showIcon: true,
    style: {
      margin: '0 auto 15px'
    }
  }), /*#__PURE__*/React.createElement(ChartView, {
    visible: visible,
    data: lineData,
    chartTitle: getName('chartTitle'),
    chartTitleTip: getName('chartTitleTip'),
    chartOnly: chartOnly,
    skuId: skuId
  }));
}

function ChartDrawer(_ref) {
  var _lineMap$chartType;

  var children = _ref.children,
      skuId = _ref.skuId,
      chartType = _ref.chartType,
      date = _ref.date,
      _ref$chartOnly = _ref.chartOnly,
      chartOnly = _ref$chartOnly === void 0 ? false : _ref$chartOnly,
      areaId = _ref.areaId,
      batchId = _ref.batchId,
      promoPrice = _ref.promoPrice,
      activityDuration = _ref.activityDuration,
      newGiftType = _ref.newGiftType,
      _ref$extInfo = _ref.extInfo,
      extInfo = _ref$extInfo === void 0 ? {} : _ref$extInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var btn = /*#__PURE__*/React.cloneElement(children, {
    onClick: function onClick() {
      setVisible(true);
    }
  });
  var lineMap = {
    1: {
      codeKey: 1,
      chartLine: '单品一件预估到手价',
      chartTitle: "\u5355\u54C1\u4E00\u4EF6\u9884\u4F30\u5230\u624B\u4EF7",
      chartTitleTip: '根据填写的促销价格自动识别在活动日期内全天可用的普惠优惠信息，并计算用户购买一件该商品的预估到手价。',
      accTitle: "\u5355\u54C1\u4E00\u4EF6\u9884\u4F30\u5230\u624B\u4EF7",
      accTitleTip: '',
      drawerTitle: /*#__PURE__*/React.createElement(React.Fragment, null, "\u5355\u54C1\u4E00\u4EF6\u9884\u4F30\u5230\u624B\u4EF7\u8BA1\u7B97\u8BE6\u60C5", /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: 12,
          fontSize: '12px',
          color: 'rgba(0, 0, 0, 0.65)'
        }
      }, extInfo.extDrawerText)),
      formula: ''
    },
    2: {
      codeKey: 1,
      chartLine: '风险价',
      chartTitle: "\u98CE\u9669\u4EF7",
      chartTitleTip: '',
      accTitle: "\u98CE\u9669\u4EF7",
      accTitleTip: '',
      drawerTitle: "\u98CE\u9669\u4EF7",
      formula: ''
    }
  }; // 合并多条线的drawerTitle

  var drawerTitle = (_lineMap$chartType = lineMap[chartType]) === null || _lineMap$chartType === void 0 ? void 0 : _lineMap$chartType['drawerTitle'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, btn, /*#__PURE__*/React.createElement(Drawer, {
    className: "chartline-wrap",
    width: 1100,
    visible: visible,
    title: drawerTitle,
    onClose: function onClose() {
      setVisible(false);
    },
    footer: [/*#__PURE__*/React.createElement(Button, {
      type: "primary",
      key: "a",
      onClick: function onClick() {
        setVisible(false);
      }
    }, "\u6211\u77E5\u9053\u4E86")]
  }, /*#__PURE__*/React.createElement(ChartLine, {
    newGiftType: newGiftType,
    visible: visible,
    skuId: skuId,
    chartType: chartType,
    date: date,
    lineMap: lineMap,
    title: drawerTitle,
    chartOnly: chartOnly,
    areaId: areaId,
    batchId: batchId,
    promoPrice: promoPrice,
    activityDuration: activityDuration
  })));
}

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) return /*#__PURE__*/React.createElement("div", null);
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error(error);
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

var css_248z = ".calculate-card-border{border:1px solid #e8e8ea;border-radius:6px;padding:10px 14px;font-size:12px;line-height:24px}.calculate-card-border .card-title{color:rgba(0,0,0,.65);font-size:14px;font-weight:700}.calculate-card-border .label{color:rgba(0,0,0,.45)}.calculate-card-border .content{color:#000}.BYBT_flexLeft{-webkit-justify-content:left;justify-content:left}.BYBT_flexCenter,.BYBT_flexLeft{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center}.BYBT_flexCenter{-webkit-justify-content:center;justify-content:center}.BYBT_flexBetween{display:-webkit-flex;display:flex;-webkit-justify-content:space-between;justify-content:space-between;-webkit-align-items:center;align-items:center}.BYBT_red{color:#ff3b30}.BYBT_blue{color:#007aff;cursor:pointer}.BYBT_yellow{color:#f58b00;cursor:pointer}.BYBT_gray{color:rgba(0,0,0,.25)}";
styleInject(css_248z);

var RealPricePath = function RealPricePath(_ref) {
  var children = _ref.children,
      realType = _ref.realType,
      rest = _objectWithoutProperties(_ref, ["children", "realType"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var RealTypeMap = new Map([['RealInclusiveHandPrice', 6], ['RealInclusiveRedPrice', 7]]);
  var btn = /*#__PURE__*/React.cloneElement(children, {
    onClick: function onClick() {
      setVisible(true);
    }
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, btn, /*#__PURE__*/React.createElement(Modal, {
    forceRender: true,
    title: "\u4EF7\u683C\u8BA1\u7B97\u8BE6\u60C5",
    onCancel: function onCancel() {
      return setVisible(false);
    },
    visible: visible,
    width: 400,
    footer: /*#__PURE__*/React.createElement("div", {
      className: "BYBT_flexCenter"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setVisible(false);
      },
      type: "primary"
    }, "\u6211\u77E5\u9053\u4E86"))
  }, /*#__PURE__*/React.createElement(PricePathContent, _extends({
    visible: visible,
    priceType: RealTypeMap.get(realType)
  }, rest))));
};

function setup(config) {
  setApiDomain(config.isShop, config.env);
}

export { ChartDrawer$1 as ChartDrawer, RealPricePath$1 as RealPricePath, ChartDrawer as UniversalChart, RealPricePath as UniversalPricePath, env, getLineDescText, setup };
